module.exports = __webpack_public_path__ + "static/living-within-limits-24a1f54d6e9610e144f9fa6e15e08e0f.jpg";